
export interface IMenuItem {
	name: string,
	uri: string,
	isCurrent: boolean,
	id: string,
	isExpanded: boolean,
	hasChildren: boolean,
	children: IMenuItem[],
	level: number
}
export interface IMenu {
	menuItems: IMenuItem[]
}
export interface IMenu {
	secondMenuItems: IMenuItem[]
}
export interface IShareLink {
	name: string,
	url: string,
	icon_class: string
}
export interface ITranslations {
	mainMenu: string,
	openMenu: string,
	closeMenu: string
}
export interface IExtraLink {
	url: string
}
export interface ITopLinks {
	displayName: string,
	uri: string,
	url: string
}
export interface ICampaignWeb {
	campaignWeb: string,
}

export interface IState {
	menuItems: IMenuItem[]
	apiURLs: {
		getChildren: string
	},
	secondMenuItems: IMenuItem[],
	translations: ITranslations,
	extraLinks: string,
	className: string,
	topLinks: ITopLinks[],
	campaignWeb: string
	shareLinks: IShareLink[],
}

const deafultState: IState = {	
	menuItems: [],	
	secondMenuItems: [],
	apiURLs: {
		getChildren: ''
	},
	translations: {
		mainMenu: '',
		openMenu: '',
		closeMenu: ''
	},
	extraLinks: '',
	className: '',
	topLinks: [],
	campaignWeb: '',
	shareLinks: [],
}

export default deafultState;